<!--
  消息中心
  jay 2020-01-14
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('personal.messageDetails')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper">
      <scroll class="detail-scroll">
        <h3 class="detail-title">{{ data.title }}</h3>
        <div
          class="detail-content"
          v-html="data.content + '【' + data.create_time + '】'"
        ></div>
      </scroll>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:detailFlag", false);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.detail-scroll {
  padding: 0 34px;
  h3 {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin: 26px 0;
  }
  .detail-content {
    line-height: 1.5;
  }
}
</style>
